const isProduction = process.env.REACT_APP_CUSTOM_ENV === 'production'
const isDev = process.env.REACT_APP_CUSTOM_ENV === 'development'

export {
    isDev,
    isProduction,
}
